(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jar-bundle-selector"] && !Shopify.designMode) return;
  try {
    class MixMatchBundle extends HTMLElement {
    connectedCallback() {
      this.sizeInputs = [...this.querySelectorAll('input[name^="bundle-size-"]')];
      this.flavourCards = [...this.querySelectorAll('[data-flavour-card]')];
      this.selection = [];
      this.bundleSize = Number(this.querySelector('input[name^="bundle-size-"]:checked')?.value || 3);
      this.currentVariant = this.dataset.currentVariant;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {
        style: 'currency',
        currency: this.dataset.currency || 'AUD'
      });

      this.sizeInputs.forEach((input) => input.addEventListener('change', () => this.changeSize(input)));
      this.flavourCards.forEach((card) => {
        card.querySelector('[data-add-flavour]')?.addEventListener('click', () => this.addFlavour(card));
        card.querySelector('[data-remove-flavour]')?.addEventListener('click', () => this.removeFlavour(card.dataset.variantId));
      });
      this.querySelector('[data-bundle-submit]')?.addEventListener('click', () => this.submitBundle());
      this.querySelector('[data-slots]')?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-remove-slot]');
        if (button) this.removeSelectionAt(Number(button.dataset.removeSlot));
      });

      const currentCard = this.flavourCards.find((card) => card.dataset.variantId === this.currentVariant);
      if (currentCard && currentCard.dataset.available === 'true') {
        this.selection.push(this.productFromCard(currentCard));
      } else if (this.currentVariant) {
        this.selection.push({
          id: this.currentVariant,
          title: this.dataset.currentTitle,
          image: this.dataset.currentImage
        });
      }

      this.render();
    }

    changeSize(input) {
      this.bundleSize = Number(input.value);
      if (this.selection.length > this.bundleSize) this.selection = this.selection.slice(0, this.bundleSize);
      this.render();
    }

    productFromCard(card) {
      return { id: card.dataset.variantId, title: card.dataset.title, image: card.dataset.image };
    }

    addFlavour(card) {
      if (this.selection.length >= this.bundleSize || card.dataset.available !== 'true') return;
      this.selection.push(this.productFromCard(card));
      this.render();
    }

    removeFlavour(variantId) {
      const index = this.selection.map((item) => item.id).lastIndexOf(variantId);
      if (index >= 0) this.selection.splice(index, 1);
      this.render();
    }

    removeSelectionAt(index) {
      if (index >= 0 && index < this.selection.length) this.selection.splice(index, 1);
      this.render();
    }

    render() {
      const selectedInput = this.sizeInputs.find((input) => Number(input.value) === this.bundleSize);
      const total = Number(selectedInput?.dataset.total || 0);
      const original = Number(selectedInput?.dataset.original || total);
      const remaining = Math.max(this.bundleSize - this.selection.length, 0);

      this.renderSlots();
      this.renderFlavourCounts();
      this.renderShipping(total);

      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = `${this.selection.length} / ${this.bundleSize} selected`;

      const summaryLabel = this.querySelector('[data-summary-label]');
      if (summaryLabel) {
        const jarWord = this.bundleSize === 1 ? this.dataset.jarSingular : this.dataset.jarPlural;
        summaryLabel.textContent = `${this.bundleSize}-${jarWord} bundle`;
      }

      const summaryTotal = this.querySelector('[data-summary-total]');
      if (summaryTotal) summaryTotal.textContent = this.formatMoney(total);

      const summaryOriginal = this.querySelector('[data-summary-original]');
      if (summaryOriginal) {
        summaryOriginal.textContent = original > total ? this.formatMoney(original) : '';
      }

      const submit = this.querySelector('[data-bundle-submit]');
      const ctaText = this.querySelector('[data-cta-text]');
      if (submit && ctaText) {
        submit.disabled = remaining > 0;
        if (remaining > 0) {
          const flavourWord = remaining === 1 ? this.dataset.oneMoreLabel : this.dataset.moreLabel;
          ctaText.textContent = `${this.dataset.chooseLabel} ${remaining} ${flavourWord}`;
        } else {
          const jarWord = this.bundleSize === 1 ? this.dataset.jarSingular : this.dataset.jarPlural;
          ctaText.textContent = `${this.dataset.addLabel} ${this.bundleSize} ${jarWord} to cart — ${this.formatMoney(total)}`;
        }
      }
    }

    renderSlots() {
      const slots = this.querySelector('[data-slots]');
      if (!slots) return;

      slots.replaceChildren();
      for (let index = 0; index < this.bundleSize; index += 1) {
        const item = this.selection[index];
        const slot = document.createElement('div');
        slot.className = `mix-match-bundle__slot${item ? ' mix-match-bundle__slot--filled' : ''}`;

        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          const label = document.createElement('span');
          label.textContent = item.title;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'mix-match-bundle__slot-remove';
          remove.dataset.removeSlot = String(index);
          remove.setAttribute('aria-label', `Remove ${item.title}`);
          remove.textContent = '×';
          slot.append(image, label, remove);
        } else {
          const label = document.createElement('span');
          label.textContent = `Choose jar ${index + 1}`;
          slot.append(label);
        }

        slots.append(slot);
      }
    }

    renderFlavourCounts() {
      const counts = this.selection.reduce((result, item) => {
        result[item.id] = (result[item.id] || 0) + 1;
        return result;
      }, {});

      this.flavourCards.forEach((card) => {
        const count = counts[card.dataset.variantId] || 0;
        const output = card.querySelector('[data-flavour-count]');
        const add = card.querySelector('[data-add-flavour]');
        const remove = card.querySelector('[data-remove-flavour]');
        if (output) output.textContent = String(count);
        if (add) add.disabled = this.selection.length >= this.bundleSize || card.dataset.available !== 'true';
        if (remove) remove.disabled = count === 0;
        card.dataset.selected = count > 0 ? 'true' : 'false';
      });
    }

    renderShipping(total) {
      const threshold = Number(this.dataset.freeShippingThreshold || 0);
      const text = this.querySelector('[data-shipping-text]');
      const progress = this.querySelector('[data-shipping-progress]');
      if (!threshold || !text || !progress) return;

      const remaining = Math.max(threshold - total, 0);
      if (remaining === 0) {
        text.textContent = 'Your bundle qualifies for free shipping';
      } else {
        text.textContent = `${this.formatMoney(remaining)} away from free shipping`;
      }
      progress.style.width = `${Math.min((total / threshold) * 100, 100)}%`;
    }

    formatMoney(cents) {
      return this.money.format(cents / 100);
    }

    async submitBundle() {
      if (this.selection.length !== this.bundleSize) return;
      const submit = this.querySelector('[data-bundle-submit]');
      const ctaText = this.querySelector('[data-cta-text]');
      const error = this.querySelector('[data-error]');
      if (!submit || !ctaText || !error) return;

      const quantities = this.selection.reduce((result, item) => {
        result[item.id] = (result[item.id] || 0) + 1;
        return result;
      }, {});
      const items = Object.entries(quantities).map(([id, quantity]) => ({ id, quantity }));

      submit.disabled = true;
      ctaText.textContent = this.dataset.addingLabel;
      error.hidden = true;

      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(this.dataset.errorLabel);
        window.location.assign(this.dataset.cartUrl);
      } catch (requestError) {
        error.textContent = requestError.message || this.dataset.errorLabel;
        error.hidden = false;
        submit.disabled = false;
        this.render();
      }
    }
  }

  if (!customElements.get('mix-match-bundle')) {
    customElements.define('mix-match-bundle', MixMatchBundle);
  }
  } catch(e) { console.error(e); }
})();

})();
